<p-button
  [rounded]="rounded()"
  [size]="size()"
  [severity]="severity()"
  [disabled]="disable()"
  [loading]="loading()"
  [variant]="variant()"
  (onClick)="onClick($event)"
  [icon]="icon() ? 'pi pi-' + icon() : undefined"
  [iconPos]="iconPos()"
  [label]="label()"
  [ariaLabel]="ariaLabel()"
  [styleClass]="buttonClass()"
  [style.color]="textColor()"
/>
